module.exports = __webpack_public_path__ + "img/03.7bb1358c.png";